<template>
  <section class="social-proof-bar py-4 bg-light-gray border-bottom">
    <div class="container">
      <div class="row align-items-center text-center">
        <!-- Metric 1 -->
        <div class="col-6 col-md-3 mb-3 mb-md-0 scroll-reveal">
          <div class="stat-number display-4 font-weight-bold text-primary-base">
            +500
          </div>
          <div
            class="stat-label text-muted font-weight-bold small text-uppercase"
          >
            Médicos y Especialistas
          </div>
        </div>

        <!-- Metric 2 -->
        <div class="col-6 col-md-3 mb-3 mb-md-0 scroll-reveal delay-1">
          <div class="stat-number display-4 font-weight-bold text-success-base">
            +100K
          </div>
          <div
            class="stat-label text-muted font-weight-bold small text-uppercase"
          >
            Mensajes Respondidos
          </div>
        </div>

        <!-- Metric 3 -->
        <div class="col-6 col-md-3 scroll-reveal delay-2">
          <div class="stat-number display-4 font-weight-bold text-primary-dark">
            89%
          </div>
          <div
            class="stat-label text-muted font-weight-bold small text-uppercase"
          >
            Menos Inasistencias
          </div>
        </div>

        <!-- Metric 4 -->
        <div class="col-6 col-md-3 scroll-reveal delay-3">
          <div class="stat-number display-4 font-weight-bold text-success-base">
            2 Horas
          </div>
          <div
            class="stat-label text-muted font-weight-bold small text-uppercase"
          >
            Ganadas al Día
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SocialProofBar',
  mounted() {
    this.initScrollObserver();
  },
  methods: {
    initScrollObserver() {
      if (
        typeof window === 'undefined'
        || !('IntersectionObserver' in window)
      ) {
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          }
        });
      }, {threshold: 0.2});

      this.$el.querySelectorAll('.scroll-reveal')
          .forEach((el) => observer.observe(el));
    },
  },
};
</script>

<style scoped>
.social-proof-bar {
  background-color: #f8faff;
}
.text-primary-dark {
  color: #002196;
}
</style>
